import React from 'react';
import PropTypes from 'prop-types';
import styles from './project-blurb.module.css';

const ProjectBlurb = ({ blurb }) => {
  return (
    <React.Fragment>
      <h5 className={styles.message}>{blurb}</h5>
    </React.Fragment>
  );
};

ProjectBlurb.propTypes = {
  blurb: PropTypes.string,
};

export default ProjectBlurb;



// WEBPACK FOOTER //
// ./src/components/project/project-blurb/index.js